module.exports = __webpack_public_path__ + "img/ET.15040bfc.svg";